import { Outlet, createFileRoute } from '@tanstack/react-router'

/**
 * Billing section layout — C1 billing · C2 plan · C4 payment.
 *
 * Deliberately chrome-free: the DS v3 frame puts the Overview/Plan/Payment strip
 * BELOW each page's `PageShell` title, so every child page renders its own
 * `SectionTabs` (shared `BILLING_TABS`). A strip here too would double it.
 */
export const Route = createFileRoute('/_ws/w/$workspaceId/billing')({
  component: BillingLayout,
})

function BillingLayout() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  )
}
